import React from 'react';
import PropTypes from 'prop-types';

import Subtitle from 'ui/text/Subtitle';
import Description from 'ui/text/Description';
import CustomChip from 'ui/CustomChip';

import formattedDate from 'utils/formattedDate';

import { Divider } from '@mui/material';


const Header = ({ event_title, title, start_date, description, checkedIn, checkedInAt }) => {

  return (
    <div className='fullwidth-card-header'>
        <Subtitle>{event_title}</Subtitle>
        <Description>{formattedDate(start_date, 'datetime')}</Description>
        <Description>{title}</Description>

        <Divider />

        <Description>{description}</Description>

        {checkedIn &&
          <>
            <CustomChip label="checked in" styleKey="active" padded />
            {checkedInAt && <Description secondary>{formattedDate(checkedInAt, 'datetime')}</Description>}
          </>}
    </div>
  );
};

Header.propTypes = {
    event_title: PropTypes.string,
    title: PropTypes.string,
    start_date: PropTypes.string,
    description: PropTypes.string,
    checkedIn: PropTypes.bool,
    checkedInAt: PropTypes.string,
};

export default Header;